<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="入库记录" name="first">
        <ruku :productTypes="productTypes" :warehouseList="warehouseList" ref=ruku v-if="activeName=='first'&&warehouseFlag" > </ruku>
      </el-tab-pane>
      <el-tab-pane label="出库记录" name="two">
        <chuku  :productTypes="productTypes" :warehouseList="warehouseList" ref=chuku v-if="activeName=='two'&&warehouseFlag"> </chuku>
      </el-tab-pane>
      <el-tab-pane label="转货记录" name="three">
        <zhuanhuo :productTypes="productTypes" :warehouseList="warehouseList" ref=zhuanhuo  v-if="activeName=='three'&&warehouseFlag"> </zhuanhuo>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ruku from '@/views/soc-stock/goodsRecord/ruku.vue'
import chuku from '@/views/soc-stock/goodsRecord/chuku.vue'
import zhuanhuo from '@/views/soc-stock/goodsRecord/zhuanhuo.vue'
import { getDictionaryGood, getDictionaryAll, warehouseList } from '@/api/soc-stock'
import { getOrganizationNameList } from '@/api/soc-stock-cosco'
export default {
  components: {
    ruku, chuku, zhuanhuo
  },
  data () {
    return {
      activeName: 'first',
      productTypes: [],
      oneCustomerTaxId: localStorage.getItem('tenantTaxpayerNumber'),
      warehouseFlag: false,
      warehouseList: []
    }
  },
  created () {
    // 获取货物类型
    getDictionaryAll({ groupNo: 'product_type' }).then(res => {
      this.productTypes = res
      this.productTypes.unshift({ show_name: '请选择', item_no: '' })
    })
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.warehouseList = [{
        relTenantName: localStorage.getItem('createTenantName'),
        relTenantCode: localStorage.getItem('createTenantCode')
      }]
      this.warehouseFlag = true
    } else {
      getOrganizationNameList({
        userCode: localStorage.getItem('userCode'),
        tenantCode: localStorage.getItem('tenantCode')
      }).then(res => {
        this.warehouseList = res
        this.warehouseFlag = true
      })
    }
  },
  mounted () {
  },
  methods: {
    handleClick () {

    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
/deep/.el-tabs__item{
  padding-left: 10px!important;
}
/deep/.el-tabs__header{
  margin: 0;
}
// /deep/.el-tabs__active-bar{
//   padding: 0 10px;
//   margin-left: -10px;
// }
</style>
